<div class="subscriber-container" #subscriberDiv>
  <div class="display-control-container">
    <sas-camera [subscriber]="subscriber" [hasVideo]="stream.hasVideo"></sas-camera>
    <sas-speaker [subscriber]="subscriber" [hasAudio]="stream.hasAudio && this.subscriberAudio" [active]="audioActive">
    </sas-speaker>
    @if(showCapturePhoto){
      <sas-capture-photo [subscriber]="subscriber" [hasVideo]="stream.hasVideo"
        [attendantName]="roomData ? roomData.attendantName : 'image'"></sas-capture-photo>
    }
  </div>
</div>